exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2P2CA7KaQthG4G2y_SL1SF {\n  display: flex;\n  flex: 1 1 auto;\n  outline: none;\n  overflow: hidden; }\n\n._12DTxlMxKbp71ZI4qAf23u {\n  overflow: auto !important;\n  height: 100% !important; }\n  ._12DTxlMxKbp71ZI4qAf23u::-webkit-scrollbar {\n    width: 9px;\n    border-radius: 10px; }\n  ._12DTxlMxKbp71ZI4qAf23u::-webkit-scrollbar-track {\n    background-color: #3A4041;\n    border-radius: 10px;\n    margin: 10px; }\n  ._12DTxlMxKbp71ZI4qAf23u::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n    background-color: #A1ACB0; }\n", ""]);

// exports
exports.locals = {
	"navContainer": "_2P2CA7KaQthG4G2y_SL1SF",
	"navScroll": "_12DTxlMxKbp71ZI4qAf23u"
};